
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $01dd1839b5376a46$exports = {};

$parcel$export($01dd1839b5376a46$exports, "flex", () => $01dd1839b5376a46$export$97691fbb80847c19, (v) => $01dd1839b5376a46$export$97691fbb80847c19 = v);
$parcel$export($01dd1839b5376a46$exports, "flex-container", () => $01dd1839b5376a46$export$69d7a39fa31a000b, (v) => $01dd1839b5376a46$export$69d7a39fa31a000b = v);
$parcel$export($01dd1839b5376a46$exports, "flex-gap", () => $01dd1839b5376a46$export$31a9da8b58047a44, (v) => $01dd1839b5376a46$export$31a9da8b58047a44 = v);
var $01dd1839b5376a46$export$97691fbb80847c19;
var $01dd1839b5376a46$export$69d7a39fa31a000b;
var $01dd1839b5376a46$export$31a9da8b58047a44;
$01dd1839b5376a46$export$97691fbb80847c19 = `vi3c6W_flex`;
$01dd1839b5376a46$export$69d7a39fa31a000b = `vi3c6W_flex-container`;
$01dd1839b5376a46$export$31a9da8b58047a44 = `vi3c6W_flex-gap`;


export {$01dd1839b5376a46$exports as default};
//# sourceMappingURL=flex-gap_css.module.js.map
